import { FormikDialog } from '@color/continuum';
import { useFormikContext } from 'formik';

import { IAddVariantPayload } from '../../../types';

import { FormFields } from './FormFields';

interface Props {
  onDismiss: () => void;
  dialogIsOpen: boolean;
}

export const FormDialog: React.FC<Props> = (props) => {
  const { onDismiss, dialogIsOpen } = props;
  const { isSubmitting, resetForm } = useFormikContext<IAddVariantPayload>();

  return (
    <FormikDialog
      title="Add variant"
      dialogIsOpen={dialogIsOpen}
      submitButtonProps={{ isLoading: isSubmitting, children: 'Add variant' }}
      cancelButtonProps={{ children: 'Cancel' }}
      onClose={() => {
        resetForm();
        onDismiss();
      }}
      fullWidth
      maxWidth="md"
    >
      <FormFields />
    </FormikDialog>
  );
};
